<section class="warning_popup_container">
  
  <!-- Content Area -->
  <div class="popup_content">
    
    <!-- Warning Icon Centered -->
    <div class="icon_wrapper" [class.exit-style]="isExitFlow()" [class.delete-style]="isDeleteFlow()">
      <mat-icon *ngIf="isExitFlow()">logout</mat-icon>
      <img *ngIf="isDeleteFlow()" src="assets/images/master/delete-icon.svg" alt="delete">
      <mat-icon *ngIf="!isExitFlow() && !isDeleteFlow()">warning_amber</mat-icon>
    </div>

    <!-- Text Messages -->
    <div class="text_container">
      <h2 class="title_text" [class.danger-title]="isDeleteFlow() || isExitFlow()">
        {{ getDisplayTitle() }}
      </h2>
      <p class="description_text">
        {{ getDisplayMessage() }}
      </p>
    </div>
  </div>

  <!-- Divider & Docked Bottom Buttons -->
  <div class="popup_actions">
    <button type="button" class="btn_cancel" (click)="closeDialog(false)">
      Go Back
    </button>
    <button type="button" class="btn_confirm" [class.danger-btn]="isDeleteFlow() || isExitFlow()" (click)="closeDialog(true)">
      {{ getConfirmButtonText() }}
    </button>
  </div>
</section>
